import './banner_section.css'

const BannerSection = ({banner, title, isCurrent}) => {

      return (
            <div className={isCurrent !== '' ? "banner_section reverse" : "banner_section"}>
                  <div className="main_banner">
                        <img src={banner} alt={title} />
                  </div>
            </div>
      )
}

export default BannerSection
